import "@fontsource/ibm-plex-sans/300.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/inria-serif/300.css";
import "@fontsource/inria-serif/400.css";
import "@fontsource/inria-serif/700.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { AppToaster, getQueryClient } from "@humanex/ui/libs";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import "./global.css";
import { initAnalytics } from "./libs/analytics";
import "./libs/i18n";
import { routeTree } from "./routeTree.gen";
import { initAuthListeners } from "./stores/auth.store";

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  // Initialize analytics
  initAnalytics();

  // Initialize auth listeners
  const cleanupAuthListeners = initAuthListeners();

  const AppContent = (
    <QueryClientProvider client={getQueryClient()}>
      <RouterProvider router={router} />
      <AppToaster />
    </QueryClientProvider>
  );

  root.render(<StrictMode>{AppContent}</StrictMode>);

  // Cleanup auth listeners when app unmounts
  window.addEventListener("beforeunload", cleanupAuthListeners);
}
